import React, { useEffect } from 'react';
import { Table, Badge } from 'react-bootstrap';
import { CheckCircle, FileText, XCircle } from 'react-bootstrap-icons';
import { logInfo } from '../../config_and_helpers/logger';

const LOG_CONTEXT = 'OrderPdfUploadOutcomeTable';

/**
 * Per-file order creation results after PDF upload (`created_orders` + failures).
 *
 * @param {Object} props
 * @param {Array<{ pdfName: string, success: boolean, orderId?: number|null, poNumber?: string|null, failureReason?: string|null }>} props.outcomes
 */
const OrderPdfUploadOutcomeTable = ({ outcomes = [] }) => {
  useEffect(() => {
    if (!Array.isArray(outcomes) || outcomes.length === 0) return;
    const successCount = outcomes.filter(r => r.success).length;
    logInfo(LOG_CONTEXT, 'Rendering order PDF upload outcome table', {
      rowCount: outcomes.length,
      successCount,
      failureCount: outcomes.length - successCount,
    });
  }, [outcomes]);

  if (!Array.isArray(outcomes) || outcomes.length === 0) {
    return null;
  }

  const successCount = outcomes.filter(r => r.success).length;

  const dash = v => (v == null || v === '' ? '—' : String(v));

  return (
    <div className="order-pdf-upload-outcomes mt-3">
      <h6 className="d-flex align-items-center gap-2 mb-2">
        <FileText size={16} className="text-primary" />
        Upload results ({successCount} of {outcomes.length} succeeded)
      </h6>
      <Table striped bordered hover responsive size="sm" className="mb-0 bg-white small">
        <thead className="table-light">
          <tr>
            <th>File</th>
            <th>Status</th>
            <th>Order ID</th>
            <th>PO / ref</th>
            <th>Reason</th>
          </tr>
        </thead>
        <tbody>
          {outcomes.map((row, index) => (
            <tr key={`order-outcome-${row.pdfName}-${index}`}>
              <td
                className="text-truncate"
                style={{ maxWidth: 220 }}
                title={row.pdfName || ''}
              >
                {row.pdfName || `File ${index + 1}`}
              </td>
              <td>
                {row.success ? (
                  <Badge bg="success" className="d-inline-flex align-items-center gap-1">
                    <CheckCircle size={12} aria-hidden />
                    Created
                  </Badge>
                ) : (
                  <Badge bg="danger" className="d-inline-flex align-items-center gap-1">
                    <XCircle size={12} aria-hidden />
                    Failed
                  </Badge>
                )}
              </td>
              <td>{row.success ? dash(row.orderId) : '—'}</td>
              <td className="text-break">{dash(row.poNumber)}</td>
              <td className="small text-break text-danger">
                {row.success ? '—' : dash(row.failureReason)}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default OrderPdfUploadOutcomeTable;
